<template>
  <LangRouterLink
    :to="{ name: 'voyage', params: { slug: voyage.slug } }"
    class="card-voyage"
    v-if="voyage"
  >
    <div
      class="card-voyage__image"
      :style="{ backgroundImage: `url(${voyage.map_id?.md || voyage.cover_id?.sm || image})` }"
    >
      <div class="card-voyage__type">
        <Icon :id="icon" />
      </div>
    </div>

    <h3 class="card-voyage__title">{{ voyage.name }}</h3>
    <h3 class="card-voyage__description">{{ description }}</h3>
  </LangRouterLink>
</template>

<script>
import Icon from '@/components/global/Icon.vue'
import LangRouterLink from '@/components/global/LangRouterLink.vue'

export default {
  name: 'VoyageCard',
  components: { Icon, LangRouterLink },
  props: {
    voyage: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: 'avion',
    },
    name: {
      type: String,
      default: 'Nom',
    },
    image: {
      type: String,
      default: 'https://placehold.co/400x200',
    },
  },
  computed: {
    description() {
      if (this.voyage.short_description) {
        if (this.voyage.short_description.length > 190) {
          return (
            this.voyage.short_description.slice(0, this.voyage.short_description.lastIndexOf(' ')) +
            '...'
          )
        }
        return this.voyage.short_description
      }
      return 'short_description'
    },
    icon() {
      return this.voyage.type === 'bus' ? 'autobus' : 'avion'
    },
  },
}
</script>
